import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery } from '@tanstack/react-query';
import API_URL from './api/config';
import ReactModal from 'react-modal';

function Register() {
    const navigate = useNavigate();

    /*const { data, isLoading, isError } = useQuery({
        queryKey: ['packageDetails'],
        queryFn: async () => {
          const res = await axios.get(`${API_URL}/register-package-api`, { withCredentials: true });
          return res.data;
        },
        staleTime: 0,
        cacheTime: Infinity
      });*/

      const { data, isLoading, isError, error } = useQuery({
        queryKey: ['packageDetails'],
        queryFn: async () => {
          const res = await axios.get(
            `${API_URL}/register-package-api`,
            { withCredentials: true }
          );
          return res.data;
        }
      });
     

      const [values, setValues] = useState({
          first_name: '',
          last_name: '',
          gender: '',
          email: '',
          new_password: '',
          confirm_password: ''
      });
  
      const [profileImageFile, setProfileImageFile] = useState(null);
      const [previewImage, setPreviewImage] = useState(null);
      const [countries, setCountries] = useState([]);
  
       const [showPw, setShowPw] = useState(false);
        const [showConfirmPw, setShowConfirmPw] = useState(false);
      
        const baseUnderline = '1px solid #b6d3c2';
        const focusUnderline = '2px solid #2e8f66';
      
        // static assets
        const bgUrl = `${process.env.PUBLIC_URL}/img/login.jpg`;
        const logoUrl = `${process.env.PUBLIC_URL}/img/logo_1.png`;
        const defaultAvatar = `${process.env.PUBLIC_URL}/img/avatar_male.png`;
  
      const handleImageChange = (e) => {
          const file = e.target.files[0];
          if (file) {
              setProfileImageFile(file);
              const reader = new FileReader();
              reader.onloadend = () => setPreviewImage(reader.result);
              reader.readAsDataURL(file);
          }
      };
  
      const handleChange = (e) => {
          setValues({ ...values, [e.target.name]: e.target.value });
      };
  
      useEffect(() => {
          axios.get(`${API_URL}/register-countries-api`)
              .then(res => setCountries(res.data))
              .catch(err => console.error("Error fetching countries:", err));
      }, []);
  
  
      const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (values.new_password !== values.confirm_password) {
      toast.error("Passwords do not match", { position: "top-right", autoClose: 3000 });
      return;
    }
  
    setIsSubmitting(true); // disable button
  
    try {
      const formData = new FormData();
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      formData.append("gender", values.gender);
      formData.append("email", values.email);
      formData.append("password", values.new_password);
  
      if (profileImageFile) {
        formData.append("profile_image", profileImageFile);
      }
  
      const res = await axios.post(`${API_URL}/register-api`, formData, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" }
      });
  
      if (res.data.Status === "Success") {
          toast.success("Registered successfully", { position: "top-right", autoClose: 3000 });
          if (values.gender === "Male") {
              localStorage.setItem('user_id', res.data.user_id);
              localStorage.setItem('family_code', res.data.family_code);
              localStorage.setItem('family_admin', res.data.family_admin);
              navigate('/home');
          } else if (values.gender === "Female") {
              localStorage.setItem('user_id', res.data.user_id);
              localStorage.setItem('family_code', res.data.family_code);
              localStorage.setItem('family_admin', res.data.family_admin);
              navigate('/sign-up-category');
          }
          
      } else {
          toast.error(res.data.Message || "Registration failed", { position: "top-right", autoClose: 3000 });
      }
  
    } catch (err) {
      if (err.response && err.response.status === 409) {
        toast.warn("Email already exists", { position: "top-right", autoClose: 3000 });
      } else {
        console.error("Registration Error:", err);
        toast.error("An error occurred during registration", { position: "top-right", autoClose: 3000 });
      }
    } finally {
      setIsSubmitting(false); // re-enable button after request
    }
  };
  
  
  
    const [termsModalOpen, setTermsModalOpen] = useState(false);
    const [loadingTerms, setLoadingTerms] = useState(true);
           
          const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
          const [loadingPrivacy, setLoadingPrivacy] = useState(true);


if (isError) return <p>Error fetching packages</p>;
if (!Array.isArray(data)) return <p>No packages found.</p>;

    return (
        <div className="bg-med-greenx text-whitex min-vh-100 d-flex align-items-center justify-content-center"
        style={{
          minHeight: '100dvh',
          backgroundImage: `url(${bgUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          padding: '16px'
        }}
        >

            <ToastContainer />
            <div className="container">

                <div className='row'>
                
        
                <div  className="col-md-5 registration_package" >
                <div className="card" style={{
                  width: '100%',
                  maxWidth: 620,
                  borderRadius: 16,                          // was 8
                  overflow: 'hidden',
                  zIndex: 1,
                  backgroundColor: 'rgba(255, 255, 255, 0.33)', // translucent
                  backdropFilter: 'blur(3px)',                   // frosted effect
                  WebkitBackdropFilter: 'blur(3px)',            // Safari support
                  padding: '20px', height: '570px'
                }}>
                <img src="img/logo.png" alt="" height="48" />
                {data.map((pkg) => (
                    <div key={pkg.id}>

                    <p style={{fontSize: '32px'}}>{pkg.name}</p>
                    
                    {pkg.details.map((detail, idx) => (

                <p style={{marginTop: '6%'}}> <i class="fa fa-check-circle" style={{color: '#194A2C', paddingRight: '10px'}}></i>
                    {detail}
                </p>
                        
                    ))}
                    </div>
                    ))}

                            
                        </div>
                        </div>
                    
                <div className='col-md-7'>
                    {/**start */}

                    <div className="bg-med-greenx text-whitex p-0x" style={{
                  width: '100%',
                  maxWidth: 620,
                  borderRadius: 16,                          // was 8
                  overflow: 'hidden',
                  zIndex: 1,
                  backgroundColor: 'rgba(255, 255, 255, 0.33)', // translucent
                  backdropFilter: 'blur(3px)',                   // frosted effect
                  WebkitBackdropFilter: 'blur(3px)'              // Safari support
                }}> 

 {/* Header */}
                <div
                  className="text-white"
                  style={{
          background: 'linear-gradient(135deg, #065c0c, #088e3e)',
          padding: '20px',
          textAlign: 'center'
        }}
        
                >
                  <img src={logoUrl} alt="Logo" height="44" className="mb-2" />
                  <h4 className="fw-bold mb-1">Create account</h4>
                  <small style={{ opacity: 0.9 }}>Join us to get started</small>
                </div>
        
                {/* Body */}
                <div className="px-3 px-sm-4 pb-4" style={{ marginTop: 10 }}>
                  {/* Avatar */}
                  <div className="text-center mb-3">
                    <div
                      className="position-relative d-inline-block"
                      style={{
                        width: 'clamp(72px, 22vw, 110px)',
                        height: 'clamp(72px, 22vw, 110px)',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        border: '3px solid #099020',
                        cursor: 'pointer'
                      }}
                      onClick={() => document.getElementById('uploadImageInput').click()}
                    >
                      <img
                        src={previewImage || defaultAvatar}
                        alt="Profile"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                      <span
                        className="position-absolute d-flex align-items-center justify-content-center"
                        style={{
                          bottom: 6,
                          right: 6,
                          background: '#075e20',
                          borderRadius: '50%',
                          padding: 8,
                          width: 'clamp(28px, 8vw, 36px)',
                          height: 'clamp(28px, 8vw, 36px)',
                          boxShadow: '0px 2px 8px rgba(0,0,0,0.3)'
                        }}
                      >
                        <i className="fas fa-camera" style={{ color: '#2e8f66', fontSize: 14 }} />
                      </span>
                      <input id="uploadImageInput" type="file" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} />
                    </div>
                  </div>
        
                  {/* Form */}
                  <form onSubmit={handleSubmit} encType="multipart/form-data">
                    {/* First & Last Name */}
                    <div className="row g-2 mb-3">
                      <div className="col-6">
                        <input
                          type="text"
                          name="first_name"
                          className="form-control w-100"
                          placeholder="First name"
                          style={{
                            backgroundColor: '#f7fdf9',
                            borderBottom: baseUnderline,
                            borderRadius: 10,
                            minWidth: 0
                          }}
                          onFocus={(e) => (e.target.style.borderBottom = focusUnderline)}
                          onBlur={(e) => (e.target.style.borderBottom = baseUnderline)}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-6">
                        <input
                          type="text"
                          name="last_name"
                          className="form-control w-100"
                          placeholder="Last name"
                          style={{
                            backgroundColor: '#f7fdf9',
                            borderBottom: baseUnderline,
                            borderRadius: 10,
                            minWidth: 0
                          }}
                          onFocus={(e) => (e.target.style.borderBottom = focusUnderline)}
                          onBlur={(e) => (e.target.style.borderBottom = baseUnderline)}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
        
                    {/* Gender & Country */}
                    <div className="row g-2 mb-3">
                      <div className="col-6">
                        <select
                          name="gender"
                          className="form-select w-100"
                          style={{
                            backgroundColor: '#f7fdf9',
                            borderBottom: baseUnderline,
                            borderRadius: 10,
                            minWidth: 0
                          }}
                          onFocus={(e) => (e.target.style.borderBottom = focusUnderline)}
                          onBlur={(e) => (e.target.style.borderBottom = baseUnderline)}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>
                      <div className="col-6">
                      <input
                        type="email"
                        name="email"
                        className="form-control w-100"
                        placeholder="Email"
                        style={{
                          backgroundColor: '#f7fdf9',
                          borderBottom: baseUnderline,
                          borderRadius: 10
                        }}
                        onFocus={(e) => (e.target.style.borderBottom = focusUnderline)}
                        onBlur={(e) => (e.target.style.borderBottom = baseUnderline)}
                        onChange={handleChange}
                        required
                      />
                      </div>
                    </div>
        
                   
        
                    {/* Passwords */}
                    <div className="row g-2 mb-3">
                      <div className="col-6 position-relative">
                        <input
                          type={showPw ? 'text' : 'password'}
                          name="new_password"
                          className="form-control w-100"
                          placeholder="Password"
                          style={{
                            backgroundColor: '#f7fdf9',
                            borderBottom: baseUnderline,
                            borderRadius: 10,
                            minWidth: 0
                          }}
                          onFocus={(e) => (e.target.style.borderBottom = focusUnderline)}
                          onBlur={(e) => (e.target.style.borderBottom = baseUnderline)}
                          onChange={handleChange}
                          required
                        />
                        <button
                          type="button"
                          onClick={() => setShowPw((prev) => !prev)}
                          className="btn btn-link p-0"
                          style={{
                            position: 'absolute',
                            right: 8,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            textDecoration: 'none',
                            color: '#666'
                          }}
                        >
                          <i className={`bi ${showPw ? 'bi-eye-slash' : 'bi-eye'}`} style={{ fontSize: 18 }} />
                        </button>
                      </div>
                      <div className="col-6 position-relative">
                        <input
                          type={showConfirmPw ? 'text' : 'password'}
                          name="confirm_password"
                          className="form-control w-100"
                          placeholder="Confirm Password"
                          style={{
                            backgroundColor: '#f7fdf9',
                            borderBottom: baseUnderline,
                            borderRadius: 10,
                            minWidth: 0
                          }}
                          onFocus={(e) => (e.target.style.borderBottom = focusUnderline)}
                          onBlur={(e) => (e.target.style.borderBottom = baseUnderline)}
                          onChange={handleChange}
                          required
                        />
                        <button
                          type="button"
                          onClick={() => setShowConfirmPw((prev) => !prev)}
                          className="btn btn-link p-0"
                          style={{
                            position: 'absolute',
                            right: 8,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            textDecoration: 'none',
                            color: '#666'
                          }}
                        >
                          <i className={`bi ${showConfirmPw ? 'bi-eye-slash' : 'bi-eye'}`} style={{ fontSize: 18 }} />
                        </button>
                      </div>
                    </div>
        
                    {/* Inline terms text */}
                    <p className="text-center small mt-3 mb-2" style={{ color: '#444' }}>
                      By signing up, you agree to our{' '}
                      <Link onClick={() => setTermsModalOpen(true)} className="fw-bold" style={{ color: '#184a2c' }}>
                        Terms of Use
                      </Link>{' '}
                      and{' '}
                      <Link onClick={() => setPrivacyModalOpen(true)} className="fw-bold" style={{ color: '#184a2c' }}>
                        Privacy Policy
                      </Link>
                    </p>
        
                    {/* Submit Button */}
                    <button
                      type="submit"
                      className="btn w-100 text-white fw-bold"
                      style={{
                        background: 'linear-gradient(90deg, #059d42, #089035)',
                        borderRadius: 50,
                        padding: '14px',
                        fontSize: '16px'
                      }}

                      disabled={isSubmitting}
                    >

                {isSubmitting ? "SIGNING UP..." : "SIGN UP"}
                      
                    </button>
        
                    {/* Login link */}
                    <div className="text-center mt-3">
                      Already have an account?{' '}
                      <Link to="/" className="fw-bold" style={{ color: '#184a2c' }}>
                        Login
                      </Link>
                    </div>
                  </form>
                </div>


            <ReactModal
                                isOpen={termsModalOpen}
                                onRequestClose={() => setTermsModalOpen(false)}
                                className="Modal modal-lg"
                                overlayClassName="Overlay" style={{
                                  overlay: { zIndex: 10000, backgroundColor: "rgba(0,0,0,0.5)" },
                                  content: { zIndex: 10001 }
                                }}
                              >
                                <div className="modal-header">
                                  <h5 className="modal-title">Terms of Use</h5>
                                  <button
                                    type="button"
                                    className="btn-close modalCloseButton"
                                    onClick={() => setTermsModalOpen(false)}
                                  ></button>
                                </div>
                          
                                <div
                                  className="modal-body p-0 position-relative"
                                  style={{ maxHeight: "60vh", overflow: "hidden" }}
                                >
                                  {loadingTerms && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "0",
                                        left: "0",
                                        right: "0",
                                        bottom: "0",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "rgba(255,255,255,0.8)",
                                        zIndex: 10,
                                      }}
                                    >
                                      <div className="spinner-border text-primaryx" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                    </div>
                                  )}
                          
                                  <iframe
                                    src="https://oret.africa/terms-and-conditions/"
                                    title="Terms of Use"
                                    style={{ width: "100%", height: "80vh", border: "none" }}
                                    onLoad={() => setLoadingTerms(false)}
                                  ></iframe>
                                </div>
                          
                                <div className="modal-footer"></div>
                              </ReactModal>
                          
                          
                          
                          
                          
                              <ReactModal
                                isOpen={privacyModalOpen}
                                onRequestClose={() => setPrivacyModalOpen(false)}
                                className="Modal modal-lg"
                                overlayClassName="Overlay"  style={{
                                  overlay: { zIndex: 10000, backgroundColor: "rgba(0,0,0,0.5)" },
                                  content: { zIndex: 10001 }
                                }}
                              >
                                <div className="modal-header">
                                  <h5 className="modal-title">Privacy Policy</h5>
                                  <button
                                    type="button"
                                    className="btn-close modalCloseButton"
                                    onClick={() => setPrivacyModalOpen(false)}
                                  ></button>
                                </div>
                          
                                <div
                                  className="modal-body p-0 position-relative"
                                  style={{ maxHeight: "60vh", overflow: "hidden" }}
                                >
                                  {loadingPrivacy && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "0",
                                        left: "0",
                                        right: "0",
                                        bottom: "0",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "rgba(255,255,255,0.8)",
                                        zIndex: 10,
                                      }}
                                    >
                                      <div className="spinner-border text-primaryx" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                    </div>
                                  )}
                          
                                  <iframe
                                    src="https://oret.africa/privacy-policy/"
                                    title="Privacy Policy"
                                    style={{ width: "100%", height: "80vh", border: "none" }}
                                    onLoad={() => setLoadingPrivacy(false)}
                                  ></iframe>
                                </div>
                          
                                <div className="modal-footer"></div>
                              </ReactModal>



                </div>

                    {/**end */}
                </div>

                </div>

                 {/* Optional tiny CSS for ultra-small widths */}
              <style>
                {`
                  @media (max-width: 360px) {
                    .form-control, .form-select { font-size: 0.9rem; }
                    .btn { padding: 12px; font-size: .95rem; }
                  }
                `}
              </style>
            </div>
        </div>
    );
}

export default Register;
